import * as React from "react";

export const fields = (type, keyName) => {
    const isPercentageScale4 = type === "PERCENTAGE_SCALE_4";
    const isPrice = type === "PRICE";

    return {
        config: {columns: 1},
        fields: [
            {
                name: "value",
                label: keyName,
                column: 1,
                type: isPercentageScale4 || isPrice ? "number" : type,
                ...(isPercentageScale4 && {
                    suffix: "%",
                    maxValue: 100,
                    defaultValue: "30",
                    scale: 4,
                    mandatory: true
                }),
                ...(isPrice && {
                    suffix: "zł",
                    minValue: 0,
                    defaultValue: "0",
                    scale: 2,
                    mandatory: true
                })
            },
            {
                name: "key",
                type: "unvisible",
                column: 1,
            }
        ]
    };
};
